import { ProcessesAction } from 'generated/resources/graphql'

import { Item } from '../item'

export enum Statuses {
  Running = 'running',
  Finalized = 'finalized',
  Stopped = 'stopped',
}

interface Step {
  id?: number | null
  name: string
  position?: number | null
  createdAt: any
  items: Array<Item>
}
interface Process {
  id: number
  name: string
  steps: Array<Step>
}

export interface MaterializedItemItem {
  id: number
  configurationId?: number | null
  configurationType?: string | null
  mandatory?: boolean | null
  instruction?: string | null
  title?: string | null
  assigneeIds?: number[]
  action?: ProcessesAction
}

export interface MaterializedItem {
  id: number
  actionIdentifier?: string | null
  dueOn?: string | null
  instruction?: string | null
  itemId?: number | null
  mandatory?: boolean | null
  resourceId?: number | null
  resourceType?: string | null
  snapshotConfigurationId?: number | null
  snapshotConfigurationType?: string | null
  status: string
  reason?: boolean | null
  title?: string | null
  createdAt: any
  assigeeIds?: number[]
  item?: MaterializedItemItem | null
}
interface ResourceRelationship {
  id: number
  resourceId: number
}

export interface MaterializedStep {
  id: number
  active?: boolean | null
  name: string
  status: string
  stepId?: number | null
  createdAt: any
  materializationSnapshot?: {
    stepProgressionCondition?: string | null
    stepProgressionConditionResourceKey?: string | null
  } | null
  materializedItems: Array<MaterializedItem>
  step: { id?: number | null }
}

export interface MaterializedProcess {
  id: number
  completedResources?: number | null
  finalizedAt?: any | null
  name: string
  status: string
  totalResources?: number | null
  materializedSteps: Array<MaterializedStep>
  process: Process
  resourceRelationships: Array<ResourceRelationship>
}
